module.exports = "<article>\n  <h2>{{this.contentful.texte('Merci - Titre')}}</h2>\n  <div [innerHtml]=\"texte\"></div>\n</article>\n"